














































































import Vue from "vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import TwilioWorkerModel from "@/models/TwilioWorkerModel";
import TwilioService from "@/services/twilio.service";
import { ConfigurationModel } from "@/models/TwilioConfigurationModel";
import BaseServiceMixin from "@/mixins/base.service.mixin";
import Respond from "@/views/Respond.vue";
import Axios from "axios";
import TwilioActivityModel from "@/models/TwilioActivitiesModel";
import TwilioTaskQueueModel from "@/models/TwilioTaskQueueModel";

@Component({
  components: {
    Respond,
  },
})
export default class WorkerExpandedInfoModal extends Mixins(BaseServiceMixin) {
  @Prop({ default: () => new TwilioWorkerModel() })
  private worker!: TwilioWorkerModel;
  @Prop({ default: () => 0 })
  private companyId!: number;

  private twilioService!: TwilioService;

  private activities: TwilioActivityModel[] = [];

  private taskQueues: TwilioTaskQueueModel[] = [];

  private selected: string = this.worker.activity;
  private choosen!: string;
  private result: any;

  public async created() {
    this.selected = this.worker.activity;
    this.twilioService = new TwilioService(this.axiosInstance);
    this.activities = await this.twilioService.getActivities(this.companyId);
    this.taskQueues = await this.twilioService.getQueues(this.companyId, this.worker.sid);
  }

  public alert(value: string) {
    alert(value);
  }

  private async onActivityChange(newvalue: string) {
    this.selected = this.activities.find((element) => element.sid == newvalue)!.friendlyname;

    const result = await this.twilioService.changeActivity(this.companyId, newvalue, this.worker.sid);
  }
}
